import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants";
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues,
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import {
  Container,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  FormHelperText,
  Fab,
  Grid,
  Paper,
  Typography,
  Tooltip,
  Chip,
  Avatar,
  Toolbar,
  MenuItem,
} from "@material-ui/core";
import { actionGetTags } from "../../actions/TagActions";
import SelectMaterial from "@material-ui/core/Select";
import AddIcon from "@material-ui/icons/Add";
import GoogleMapLocation from "../../components/GoogleMapLocation";
import { withTheme } from "@material-ui/core/styles";
import BackIcon from "@material-ui/icons/ArrowBackRounded";
import Util, { ERROR, SUCCESS } from "../../common/Util";
import ImageSelector from "../../components/ImageSelector/ImageSelector";
import { actionSaveEvent } from "../../actions/EventActions";
import { actionSavePlace, actionGetPlaces } from "../../actions/PlaceActions";
import Settings from "../../provider/base/Settings";
import _ from "lodash";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";

let _handleSubmitFail;
const filterTag = createFilterOptions();

class AddEditEvents extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      imgEdit: null,
      imgNameEdit: null,
      addPlace: false,
      imgError: "",
      tags: [],
      placeError: "",
      newPlaceName: "",
      newPlaceLocation: null,
      newPlaceAddress: "",
      placeSelected: "",
      placeItemSelected: null,
      copyTickets: true,
      errorPlaceName: undefined,
      tagsSelected: [],
      errorPlaceAddress: undefined,
    };
    this.onClean = this.onClean.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onSaveNewPlace = this.onSaveNewPlace.bind(this);
    this.onSelectTag = this.onSelectTag.bind(this);
    this.onChangePlace = this.onChangePlace.bind(this);
    this.onChangePlacesName = this.onChangePlacesName.bind(this);
    this.onDeleteRenderTag = this.onDeleteRenderTag.bind(this);
    this.onChangePlacesAddress = this.onChangePlacesAddress.bind(this);
    this.getPlaces = this.getPlaces.bind(this);
    _handleSubmitFail = this.handleSubmitFail.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { event: lastEventFormValues = {} } = this.props;
    const { evtTags: lastEvtTags = [] } = lastEventFormValues;
    const { event: newEvtFormValues = {} } = nextProps;
    const { tktTags: newEvtTags = [] } = newEvtFormValues;

    if (!this.isArrayEqual(lastEvtTags, newEvtTags)) {
      this.setState({
        tagsSelected: lastEvtTags,
      });
    }
  }
  isArrayEqual(x, y) {
    return _(x)
      .differenceWith(y, _.isEqual)
      .isEmpty();
  }
  componentWillMount() {
    if (!this.props.login) {
      this.props.history.replace(LOGIN_ROUTE);
    }

    if (this.props.isEditing || this.props.isCopy) {
      let event = this.props.event;
      if (event) {
        event.evtDateTime =
          event.evtDateTime &&
          Util.timestampToMoment(event.evtDateTime).format("YYYY-MM-DDTHH:mm");
        event.evtInitDate =
          event.evtInitDate &&
          Util.timestampToMoment(event.evtInitDate).format("YYYY-MM-DDTHH:mm");
        event.evtEndDate =
          event.evtEndDate &&
          Util.timestampToMoment(event.evtEndDate).format("YYYY-MM-DDTHH:mm");
        if (Settings.IS_USER_VERIFIED) {
          event.evtSellVerify = event.evtSellVerify || false;
        }
        this.props.initialize(event);
        this.getPlaces(() => {
          let placesFiltered = this.props.placeList.filter((p) => {
            return p.plcName == event.evtPlace;
          });
          if (placesFiltered && placesFiltered.length) {
            this.setState({
              placeSelected: placesFiltered[0].plcName,
              placeItemSelected: placesFiltered[0],
            });
          }
        });
        this.setState({ imgEdit: event.evtImg, imgNameEdit: event.evtImgName });
      } else {
        this.props.history.replace(LOGIN_ROUTE);
      }
    } else {
      let event = { evtState: "active", evtSellRrppEnable: false };
      if (Settings.IS_USER_VERIFIED) {
        event.evtSellVerify = false;
      }
      this.props.initialize(event);
      this.getPlaces();
    }
    this.props.actionGetTags(
      () => {
        this.setState({ tags: this.props.tagList });
      },
      (e) => {
        console.log("ERROR AL LISTAR TAGS", e);
      }
    );
  }

  getPlaces(success) {
    this.props.actionGetPlaces(success, (e) => {
      if (!(e && e.status && e.status == 401))
        Util.showNoty(ERROR, "No pudimos listar las ubicaciones");
    });
  }

  handleSubmitFail(error) {
    console.log("ERROR EN EL SUBMIT", error);
    if (error.evtImg) {
      this.setState({ imgError: error.evtImg });
    }
    if (!this.state.placeSelected) {
      this.setState({ placeError: required(null) });
    }
  }

  onClean() {
    let cleanEvent = { evtState: "active", evtSellRrppEnable: "false" };
    if (this.props.isEditing) {
      let event = this.props.event;
      if (Settings.IS_USER_VERIFIED) {
        cleanEvent.evtSellVerify = "false";
      }
      cleanEvent.evtImgPath = event.evtImgPath;
      cleanEvent.id = event.id;
      this.props.initialize();
    } else {
      if (Settings.IS_USER_VERIFIED) {
        cleanEvent.evtSellVerify = "false";
      }
      this.props.initialize(cleanEvent);
    }
    this.setState({
      imgEdit: null,
      imgNameEdit: null,
      imgError: "",
      placeError: "",
    });
  }

  onSave(formValues) {
    const { tagsSelected = [] } = this.state;
    formValues.evtTags = tagsSelected;
    if (!this.state.placeSelected) {
      this.setState({ placeError: required(null) });
      return;
    }
    const isCopyWithTickets = this.props.isCopy && this.state.copyTickets;
    if (this.props.isCopy && !this.state.copyTickets) {
      //Si estoy copiando pero no seleccionó la opción para copiar tickets
      delete formValues.id; //Quito el id para que haga la copia del evento
    }
    this.props.actionSaveEvent(
      formValues,
      isCopyWithTickets,
      () => {
        Util.showNoty(SUCCESS, "El evento se guardó correctamente.");
        this.props.history.goBack();
      },
      (e) => {
        console.log("ERROR ON SAVE EVENT", e);
        if (!(e && e.status && e.status == 401))
          Util.showNoty(ERROR, "No se pudo guardar el evento.");
      }
    );
  }

  onSaveNewPlace() {
    if (this.state.newPlaceName && this.state.newPlaceAddress) {
      let placeLocation = {
        _latitude: this.state.newPlaceLocation.lat(),
        _longitude: this.state.newPlaceLocation.lng(),
      };
      let place = {
        plcName: this.state.newPlaceName,
        plcAddress: this.state.newPlaceAddress,
        plcCoordinates: placeLocation,
      };
      this.props.actionSavePlace(
        place,
        (newPlace) => {
          this.onChangePlace(null, newPlace)
          this.getPlaces()
        },
        (e) => {
          console.log("ERROR ON SAVE NEW PLACE", e);
          if (!(e && e.status && e.status == 401))
            Util.showNoty(ERROR, "No pudimos agregar la ubicación");
        }
      );
      this.setState({ addPlace: false});
    } else {
      if (!this.state.newPlaceName) {
        this.setState({
          errorPlaceName: "Debe ingresar un nombre para la ubicación",
        });
      }
      if (!this.state.newPlaceAddress) {
        this.setState({
          errorPlaceAddress: "Debe ingresar una dirección para la ubicación",
        });
      }
    }
  }

  onChangePlace(evt, place) {
    console.log("ON CHANGE PLACE", place)
    if (place) {
      this.props.change("evtPlaceId", place.id);
      this.props.change("evtPlace", place.plcName);
      this.props.change("evtPlaceAddress", place.plcAddress);
      this.props.change("evtCoordinates", place.plcCoordinates);
      this.setState({
        placeSelected: place.plcName,
        placeItemSelected: place,
        placeError: "",
      });
    } else {
      this.props.change("evtPlaceId", null);
      this.props.change("evtPlace", null);
      this.props.change("evtPlaceAddress", null);
      this.props.change("evtCoordinates", null);
      this.setState({ placeSelected: "", placeItemSelected: null });
    }
  }

  onSelectTag(evt, tag) {
    let tags = tag.slice();
    this.setState({ tagsSelected: tags });
  }
  onDeleteRenderTag(type, tag) {
    let tags = null;
    let idx = -1;
    tags = this.state.tagsSelected.slice();
    idx = tags.findIndex((t) => t.id == tag.id);
    if (idx >= 0) {
      tags.splice(idx, 1);
    }
    this.setState({ tagsSelected: tags });
    console.log("ON DELETE RENDER TAG", type, tag, idx);
  }

  onChangePlacesName(evt) {
    const txt = evt.target.value;
    if (txt) {
      this.setState({ newPlaceName: txt, errorPlaceName: undefined });
    } else {
      this.setState({
        newPlaceName: txt,
        errorPlaceName: "Debe ingresar un nombre para la ubicación",
      });
    }
  }

  renderTags(type, tags) {
    let t = tags && tags.filter((t) => !t.add);
    return (
      t &&
      t.map((tag) => (
        <Chip
          label={tag.tagName}
          onDelete={this.onDeleteRenderTag.bind(this, type, tag)}
          avatar={
            <Avatar
              style={{ backgroundColor: tag.tagColor, color: "rgb(0,0,0,0.60" }}
            >
              {tag.tagName.substring(0, 1)}
            </Avatar>
          }
        />
      ))
    );
  }

  onChangePlacesAddress(evt) {
    const txt = evt.target.value;
    if (txt) {
      this.setState({ newPlaceAddress: txt, errorPlaceAddress: undefined });
    } else {
      this.setState({
        newPlaceAddress: txt,
        errorPlaceAddress: "Debe ingresar una dirección para la ubicación",
      });
    }
  }

  render() {
    const { theme, handleSubmit, isEditing, isCopy } = this.props;
    const title = isEditing
      ? "Editar Evento"
      : isCopy
      ? "Copiar Evento"
      : "Crear Evento";
    return (
      <Box style={theme.mainContainer}>
        <Box
          style={{
            ...theme.title.container,
            flexDirection: "row",
            display: "flex",
          }}
        >
          <Box style={theme.title.backIconContainer}>
            <IconButton
              onClick={this.props.history.goBack}
              style={theme.title.backIcon}
            >
              <BackIcon
                style={{ fontSize: "2.5rem" }}
                stroke="white"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Crear Eventos</Typography>
            <Typography variant="subtitle1">Crea Eventos</Typography>
          </Box>
        </Box>
        <Container>
          <Paper>
            <Typography style={theme.paper.title} variant="h2">
              {title}
            </Typography>
            <form style={theme.paper.form}>
              <Grid container xs={12} spacing={3} direction="row">
                <Grid item xs={4}>
                  <Field
                    component={TextField}
                    name="evtTitle"
                    label="Título del evento"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Field
                    component={TextField}
                    name="evtDescription"
                    label="Descripción"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row">
                <Grid item xs={4}>
                  <FormControl
                    fullWidth
                    error={this.state.imgError ? true : false}
                  >
                    <ImageSelector
                      fieldName="evtImg"
                      validate={[required]}
                      fileDimentions={{ width: 750, height: 370 }}
                      styleButton={theme.imageSelector}
                      imagePreviewUrl={this.state.imgEdit}
                      fileName={this.state.imgNameEdit}
                      fileSize={400000}
                      noPreview
                      onChangeState={() => {
                        this.setState({ imgError: "" });
                      }}
                    />
                    <FormHelperText>{this.state.imgError}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid container xs={8}>
                  <Grid container direction="row" xs={12} spacing={3}>
                    <Grid item xs={8}>
                      <Field
                        component={TextField}
                        name="evtDateTime"
                        label="Fecha del evento"
                        type="datetime-local"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        validate={[required]}
                      />
                    </Grid>
                    {/* <Grid item xs={4}>
                      <Field
                        component={TextField}
                        name="evtHour"
                        label="Hora del evento"
                        type="time"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        validate={[required]}
                      />
                    </Grid> */}
                    <Grid item xs={4}>
                      <FormControl
                        fullWidth
                        error={this.state.placeError ? true : false}
                      >
                        <Box
                          className="display-flex"
                          style={{ alignItems: "flex-end" }}
                          fullWidth
                        >
                          <Autocomplete
                            options={this.props.placeList}
                            getOptionLabel={(option) => option.plcName}
                            renderInput={(params) => {
                              return (
                                <TextField
                                  {...params}
                                  fullWidth
                                  label="Ubicación"
                                  error={this.state.placeError ? true : false}
                                />
                              );
                            }}
                            onChange={this.onChangePlace}
                            value={this.state.placeItemSelected}
                            inputValue={this.state.placeSelected}
                            freeSolo
                          />
                          <Fab
                            onClick={() =>
                              this.setState({
                                addPlace: true,
                                newPlaceName: "",
                                newPlaceLocation: null,
                                newPlaceAddress: "",
                              })
                            }
                            color="primary"
                            size="small"
                            style={{ height: 30, marginLeft: 6 }}
                          >
                            <AddIcon fontSize="small" />
                          </Fab>
                        </Box>
                        <FormHelperText>{this.state.placeError}</FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" xs={12} spacing={3}>
                    <Grid item xs={5}>
                      <Field
                        component={TextField}
                        name="evtInitDate"
                        label="Fecha/Hora Inicio disponibilidad"
                        type="datetime-local"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        validate={[required]}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Field
                        component={TextField}
                        name="evtEndDate"
                        label="Fecha/Hora Fin disponibilidad"
                        type="datetime-local"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        validate={[required]}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <InputLabel shrink>¿Evento Activo?</InputLabel>
                      <Field
                        component={Select}
                        select
                        name="evtState"
                        fullWidth
                        validate={[required]}
                      >
                        <MenuItem value="active">ACTIVO</MenuItem>
                        <MenuItem value="inactive">INACTIVO</MenuItem>
                      </Field>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Field
                  component={TextField}
                  name="evtConditions"
                  label="Condiciones del evento"
                  fullWidth
                  multiline
                  validate={[required]}
                />
              </Grid>
              <Grid container xs={12} spacing={3} justify="center">
                {Settings.IS_USER_VERIFIED && (
                  <Grid item xs={3} spacing={0} justify="center">
                    <InputLabel shrink>¿Venta verificada?</InputLabel>
                    <Field
                      component={Select}
                      select
                      name="evtSellVerify"
                      fullWidth
                      validate={[required]}
                    >
                      <MenuItem value={true}>SI</MenuItem>
                      <MenuItem value={false}>NO</MenuItem>
                    </Field>
                  </Grid>
                )}
                <Grid item xs={3} spacing={0} justify="center">
                  <InputLabel shrink>¿Habilitada venta RRPP?</InputLabel>
                  <Field
                    component={Select}
                    select
                    name="evtSellRrppEnable"
                    fullWidth
                    validate={[required]}
                  >
                    <MenuItem value={true}>SI</MenuItem>
                    <MenuItem value={false}>NO</MenuItem>
                  </Field>
                </Grid>
                {this.props.isCopy && (
                  <Grid item xs={3} spacing={0} justify="center">
                    <InputLabel shrink>
                      ¿Copiar Tipo de Tickets?. Recuerde verificar la fecha de
                      disponiblidad de los mismos
                    </InputLabel>
                    <SelectMaterial
                      fullWidth
                      validate={[required]}
                      value={this.state.copyTickets}
                      onChange={(evt) => {
                        this.setState({ copyTickets: evt.target.value });
                      }}
                    >
                      <MenuItem value={true}>SI</MenuItem>
                      <MenuItem value={false}>NO</MenuItem>
                    </SelectMaterial>
                  </Grid>
                )}
                <Box
                  style={{
                    display: "flex",
                    width: "40%",
                    marginLeft: 10,
                    paddingRight: 10,
                    marginTop: 24,
                  }}
                >
                  <Autocomplete
                    options={this.state.tags}
                    value={this.state.tagsSelected}
                    getOptionLabel={(option) => option.tagName}
                    filterOptions={(options, params) => {
                      return filterTag(options, params);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        label="Asocia el evento a un tag"
                      />
                    )}
                    renderTags={this.renderTags.bind(this, "filter")}
                    onChange={this.onSelectTag}
                    loadingText="Cargando tags ..."
                    noOptionsText="Sin tags"
                    selectOnFocus
                    multiple
                    freeSolo
                    filterSelectedOptions
                  />
                </Box>
              </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button
                variant="contained"
                color="secondary"
                style={theme.footer.button}
                onClick={this.onClean}
              >
                Limpiar
              </Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button
                variant="contained"
                color="secondary"
                style={theme.footer.button}
                onClick={this.props.history.goBack}
              >
                Cancelar
              </Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button
                variant="contained"
                color="primary"
                style={theme.footer.button}
                onClick={handleSubmit(this.onSave)}
              >
                Guardar
              </Button>
            </Tooltip>
          </Toolbar>
        </Container>
        <Dialog
          open={this.state.addPlace}
          draggable
          onClose={() => this.setState({ addPlace: false })}
          disableBackdropClick
          fullWidth
          style={{ zIndex: 900 }}
          PaperProps={{ style: { maxWidth: 800 } }}
        >
          <DialogTitle>Agregar Ubicación</DialogTitle>
          <DialogTitle>
            <Box className="display-flex">
              <TextField
                label="Nombre"
                fullWidth
                value={this.state.newPlaceName}
                onChange={this.onChangePlacesName}
                error={this.state.errorPlaceName ? true : false}
                helperText={this.state.errorPlaceName}
              />
              <TextField
                label="Dirección"
                fullWidth
                value={this.state.newPlaceAddress}
                onChange={this.onChangePlacesAddress}
                style={{ marginLeft: 10 }}
                error={this.state.errorPlaceAddress ? true : false}
                helperText={this.state.errorPlaceAddress}
              />
            </Box>
          </DialogTitle>
          <GoogleMapLocation
            onChangeLocation={(value) =>
              this.setState({ newPlaceLocation: value })
            }
            onChangeAddress={(value) =>
              this.setState({ newPlaceAddress: value })
            }
          />
          <DialogActions>
            <Tooltip title="Cerrar">
              <Button
                variant="contained"
                color="secondary"
                onClick={() => this.setState({ addPlace: false })}
              >
                Cerrar
              </Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button
                variant="contained"
                color="primary"
                onClick={this.onSaveNewPlace}
              >
                Guardar
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}
function mapStateToProps(store) {
  // console.log("STORE EVENT", store)
  return {
    login: store.auth.login,
    tagList: store.tag.tagList,
    placeList: store.plc.placeList,
    event: store.evt.event,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSaveEvent,
      actionSavePlace,
      actionGetPlaces,
      actionGetTags,
    },
    dispatch
  );
}

export default reduxForm({
  form: "addEditEvent",
  onSubmitFail: (errors) => _handleSubmitFail(errors),
})(
  withRouter(
    withTheme(connect(mapStateToProps, mapDispatchToProps)(AddEditEvents))
  )
);



// WEBPACK FOOTER //
// ./src/screens/events/AddEditEvent.js